import React from 'react';
import { apiIsLoggedIn } from '../../../api/api';
import ReunionPhotosTableTab from './ReunionPhotosTableTab';

class ReunionPhotosTable extends React.Component {
    constructor(props) {
        super(props);

        this.handlePageSwitch = this.handlePageSwitch.bind(this);

        this.state = {
            numberOfPages: Math.ceil(props.photoList.length / 10),
            currentPage: 1,
            currentList: props.photoList.slice(0, 10),
        }
    }

    async componentDidMount() {
        const isLoggedIn = await apiIsLoggedIn();
        if (!isLoggedIn) {
            return;
        }
    }

    handlePageSwitch(page) {
        const newIndex = page - 1;
        if (newIndex < 0 || newIndex >= this.state.numberOfPages) {
            return;
        }

        const newList = this.props.photoList.slice(10 * newIndex, 10 * newIndex + 10);

        this.setState({
            ...this.state,
            currentPage: page,
            currentList: newList,
        });
    }

    render() {
        const buttonStyle = {
            background: "none",
            border: "none",
            padding: 0,
            margin: 0,
            font: "inherit",
            cursor: "pointer",
            outline: "inherit",
            fontWeight: "bold",
            textDecoration: "underline",
        }

        const currentButtonStyle = {
            ...buttonStyle,
            color: "grey",
            textDecoration: "none",
            pointerEvents: "none",
        }

        return (
            <div style={{marginLeft: "10%", marginRight: "10%", marginTop: "5%"}}>
                <ReunionPhotosTableTab photoList={this.state.currentList}/>
                {this.state.numberOfPages > 1 ? 
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                        <button key="<" style={this.state.currentPage === 1 ? currentButtonStyle : buttonStyle} onClick={() => this.handlePageSwitch(this.state.currentPage - 1)}>&lt;</button>
                        {[...Array(this.state.numberOfPages).keys()].map((n) => {
                            return (<button key={n + 1} style={this.state.currentPage === n + 1 ? currentButtonStyle : buttonStyle} onClick={() => this.handlePageSwitch(n + 1)}>{n + 1}</button>)
                        })}
                        <button key=">" style={this.state.currentPage === this.state.numberOfPages ? currentButtonStyle : buttonStyle} onClick={() => this.handlePageSwitch(this.state.currentPage + 1)}>&gt;</button>
                    </div>
                : null}
            </div>
        )
    }
}

export default ReunionPhotosTable;
